module.exports = __webpack_public_path__ + "static/img/qrcode.d6d1dd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qrcode.png
// module id = cgBV
// module chunks = 1